
import { Loading } from 'notiflix/build/notiflix-loading-aio';

export const LoadingSpinner = {
    Circle: () => {
        Loading.circle();
    },
    Remove: () => {
        Loading.remove()
    }
}